<template>
  <v-layout justify-center>
    <v-flex>
      
      <v-container fluid class="ma-0">
        <v-layout row wrap>
          <v-flex>
              <iframe
                id="frm_window"
                frameborder="0"
                :src="iframe.url"
                width="100%"
                :height="iframe.height"
								scrolling="no"
              ></iframe>
          </v-flex>
        </v-layout>
      </v-container>
      
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";
import query_builder from "../../functions/query.builder";

export default {
  name: "iFrameFull_arg",
  // components: {
  //   Breadcrumbs: Breadcrumbs
  // },
  data: () => ({
    iframe: {
      // visible: false,
      url: "",
			height: "1200px",
    }
  }),
  mounted: async function() {
    // var pageUUID = common.App.get_pageUUID();
    var card = [];

    var qb = new query_builder.QueryBuilder();
		// qb.Table = "file_upload_listing";
    // qb.Select = [{value:"name"},{value:"g_status_id"}];
    // must check sortBy before push in order array
    qb.Order = [
			{
				name: "order",
				descending: true,
			}
		];
    let rule = new query_builder.Rule();
    rule
      .field("_id")
      .operator(query_builder.A_STR_OPERATOR.EQUAL)
      .value(common.App.getQueryString("_id"));
    qb.Where.rules.push(rule);
    qb.Offset = 1;
    let res = await common.wBackEndComm.PostData("process_arango_qb_asset/", qb);
		res = res.data;
		if (res.Status == 1) {
      card = res.Body[0].records;
      card[0].component_path = card[0].component_path? JSON.parse(card[0].component_path): "";
		} else {
			common.wMsgBox.Error(res.Description);
		}


		this.iframe.url = card[0].component_path.iframe_path;

    if (card[0].component_path.iframe_height) {
      this.iframe.height = card[0].component_path.iframe_height;
    }
		
  }
};
</script>

<style>
</style>